import { ReactComponent as AnimatedLoadingSvg } from '../../../../assets/icons/AnimatedLoading.svg';

import { createIconComponent } from './createIconComponent';

export const AnimatedLoadingIcon = createIconComponent(AnimatedLoadingSvg);
